import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { clearAllScrollPositions, resolveScrollMemoryPageRoot } from "./parts";

/**
 * Forgets every remembered scroll offset once the user leaves a page, so coming back to it starts
 * at the top and only a refresh of the page you are on puts you back where you were.
 *
 * Mounted once by the layout, not per page: eviction tied to a page wrapper's mount misses the
 * routes that have no wrapper (profile, help topics), so returning from one of those restored a
 * stale offset, and it fires a second time for the wrapper nested inside a drawer, which would wipe
 * the host page's offsets as soon as a drawer for another entity exists.
 */
export const useScrollPositionPageReset = (): void => {
  const { pathname } = useLocation();
  const pageRoot = resolveScrollMemoryPageRoot(pathname);
  const previousPageRootRef = useRef(pageRoot);

  useEffect(() => {
    if (previousPageRootRef.current === pageRoot) {
      return;
    }

    previousPageRootRef.current = pageRoot;
    clearAllScrollPositions();
  }, [pageRoot]);
};
